import { useJsonCookieState } from "~/lib/use-cookie-state";
import type { SupportedLocale } from "~/lib/use-locale-preference";
import type { SupportedCurrency } from "~/lib/use-currency-preference";

// Single cookie for locale/currency (and future similar display/market preferences),
// stored as JSON so each field can be read/written independently without clobbering siblings.
interface LocalizationPreferences {
  locale: SupportedLocale;
  currency: SupportedCurrency;
}

const LOCALIZATION_COOKIE = "localization";

const DEFAULT_LOCALIZATION: LocalizationPreferences = {
  locale: "en-US",
  currency: "usd",
};

export function useLocalizationPreferences(): [LocalizationPreferences, (next: Partial<LocalizationPreferences>) => void] {
  return useJsonCookieState<LocalizationPreferences>(LOCALIZATION_COOKIE, DEFAULT_LOCALIZATION);
}
